export const MuiTooltip = {
  defaultProps: { placement: 'top' },
  styleOverrides: { tooltip: { backdropFilter: 'blur(6px)' } },
};
